import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import Header from "../../../layout/Header/Header";
import {
  Button,
  Row,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Input,
  Label,
  ButtonGroup,
  Col,
} from "reactstrap";
import Swal from "sweetalert2";
import ExportJsonExcel from "js-export-excel";
import axios from "axios";
import { TableHeader, Pagination, Search } from "../../../DataTable";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import SelectorGrupos from "../../../common/SelectorGrupos";
import moment from "moment";

// Claves planas por grupo (se generan al recibir la data)
const kCant = (id) => `c_${id}`;
const kPPB = (id) => `ppb_${id}`;
const kCost = (id) => `cost_${id}`;
const kPPN = (id) => `ppn_${id}`;
const kUtil = (id) => `util_${id}`;

function ReporteVentasArticulosMP() {
  const { user } = useContext(AuthContext);

  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_MARCAS = process.env.REACT_APP_URL_MARCAS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 15);

  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");

  const [marcas, setMarcas] = useState([]);
  const [selectedMarca, setSelectedMarca] = useState("");

  // Columnas = grupos que devuelve el backend: [{ id, name }]
  const [gruposCols, setGruposCols] = useState([]);

  // Grupos elegidos antes de generar el reporte
  const [gruposSel, setGruposSel] = useState([]);
  const [gruposInfo, setGruposInfo] = useState([]);
  const [modalGrupos, setModalGrupos] = useState(true);

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(endDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [modalMail, setModalMail] = useState(false);
  const toggleMail = () => setModalMail(!modalMail);
  const [mailTo, setMailTo] = useState("");

  const [cargando, setCargando] = useState(false);
  const [fechaModificada, setFechaModificada] = useState(false);

  const [comments, setComments] = useState([]);
  const [loader, showLoader, hideLoader] = useFullPageLoader();

  const [totalItems, setTotalItems] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [search, setSearch] = useState("");
  const [sorting, setSorting] = useState({ field: "", order: "" });

  const ITEMS_PER_PAGE = 50;

  const money = (value) =>
    new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    }).format(Number(value || 0));

  const number = (value) =>
    new Intl.NumberFormat("en-US").format(Number(value || 0));

  const percent = (value) =>
    `${new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(Number(value || 0))} %`;

  const marginStyle = (value) => {
    const margen = Number(value || 0);
    if (margen < 15) return { backgroundColor: "#ed8c8c" };
    if (margen > 25) return { backgroundColor: "#64e379" };
    return {};
  };

  // Utilidad: fondo verde si > 0, rojo si < 0 (igual estilo que Margen Bruto)
  const utilidadStyle = (value) => {
    const u = Number(value || 0);
    if (u > 0) return { backgroundColor: "#64e379" };
    if (u < 0) return { backgroundColor: "#ed8c8c" };
    return {};
  };

  // Campos numericos (totales + por grupo) para busqueda/orden
  const numericFields = useMemo(() => {
    const base = [
      "TotalCantidad",
      "TotalPrecioPromedioBruto",
      "TotalPrecioPromedioNeto",
      "MargenBruto",
      "TotalVentasBrutas",
      "TotalVentasNetas",
    ];
    gruposCols.forEach((g) => {
      base.push(kCant(g.id), kPPB(g.id), kCost(g.id), kPPN(g.id), kUtil(g.id));
    });
    return base;
  }, [gruposCols]);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`,
      title: "Danos unos segundos....",
      customClass: {
        icon: "animated-icon",
      },
    });
  }

  // Marcas (una sola vez)
  useEffect(() => {
    axios
      .get(URL_MARCAS, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((response) => {
        setMarcas(response.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // Cargar el reporte al elegir grupos
  useEffect(() => {
    if (!gruposSel.length) return;
    BuscaInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gruposSel]);

  const confirmarGrupos = (ids, grupos) => {
    setGruposSel(ids);
    setGruposInfo(grupos);
    setModalGrupos(false);
  };

  // Aplana porGrupo en claves planas por grupo para orden/busqueda/render
  const aplanar = (articulos, grupos) =>
    (articulos || []).map((a) => {
      const row = { ...a };
      grupos.forEach((g) => {
        const d = (a.porGrupo && a.porGrupo[g.id]) || {};
        row[kCant(g.id)] = Number(d.Cantidad || 0);
        row[kPPB(g.id)] = Number(d.PrecioPromedioBruto || 0);
        row[kCost(g.id)] = Number(d.Costo || 0);
        row[kPPN(g.id)] = Number(d.PrecioPromedio || 0);
        row[kUtil(g.id)] = Number(d.Utilidad || 0);
      });
      return row;
    });

  function BuscaInfo() {
    if (!gruposSel.length) return;
    setComments([]);
    setCargando(true);

    const q = `?grupos=${gruposSel.join(",")}`;
    axios
      .get(
        `${URL_ARTICULOS_SURTIDOS}FechasVentaArticulosMP/${selectedFechaInicio}/${selectedFechaFin}${q}`,
        {
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        }
      )
      .then((response) => {
        const grupos = (response.data && response.data.grupos) || [];
        const articulos = (response.data && response.data.articulos) || [];
        setGruposCols(grupos);
        setComments(aplanar(articulos, grupos));
        setCargando(false);
        setFechaModificada(false);
        setCurrentPage(1);
        Toast.close();
      })
      .catch((err) => {
        console.log(err);
        setCargando(false);
        Toast.close();
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "No se pudo cargar el reporte",
        });
      });
  }

  function excel() {
    const baseFilter = ["SKU", "Articulo", "Marca", "Linea"];
    const baseHeader = ["SKU", "Artículo", "Marca", "Categoria"];
    const totFilter = ["TotalCantidad", "TotalPrecioPromedioBruto", "TotalPrecioPromedioNeto", "MargenBruto", "TotalVentasBrutas", "TotalVentasNetas"];
    const totHeader = ["Total Vendido", "Total Precio Promedio Bruto", "Total Precio Promedio Neto", "Margen Bruto", "Total Ventas Brutas", "Total Ventas Netas"];

    const grpFilter = [];
    const grpHeader = [];
    gruposCols.forEach((g) => {
      grpFilter.push(kCant(g.id), kPPB(g.id), kCost(g.id), kPPN(g.id), kUtil(g.id));
      grpHeader.push(`Vendido ${g.name}`, `Precio Prom Bruto ${g.name}`, `Costos ${g.name}`, `Precio Prom Neto ${g.name}`, `Utilidad ${g.name}`);
    });

    const sheetFilter = [...baseFilter, ...grpFilter, ...totFilter];
    const sheetHeader = [...baseHeader, ...grpHeader, ...totHeader];

    const dataExcel = filteredComments.map((a) => {
      const row = { SKU: a.SKU, Articulo: a.Articulo, Marca: a.Marca, Linea: a.Linea, idMarca: a.idMarca };
      gruposCols.forEach((g) => {
        row[kCant(g.id)] = a[kCant(g.id)];
        row[kPPB(g.id)] = a[kPPB(g.id)];
        row[kCost(g.id)] = a[kCost(g.id)];
        row[kPPN(g.id)] = a[kPPN(g.id)];
        row[kUtil(g.id)] = a[kUtil(g.id)];
      });
      row.TotalCantidad = a.TotalCantidad;
      row.TotalPrecioPromedioBruto = a.TotalPrecioPromedioBruto;
      row.TotalPrecioPromedioNeto = a.TotalPrecioPromedioNeto;
      row.MargenBruto = a.MargenBruto;
      row.TotalVentasBrutas = a.TotalVentasBrutas;
      row.TotalVentasNetas = a.TotalVentasNetas;
      return row;
    });

    // Resumen por grupo (lo mismo que se muestra arriba)
    const resumenData = resumenGrupo.map((r) => ({
      Grupo: r.Grupo,
      CantidadDeArticulos: r.Cantidad,
      Venta: Number((r.Venta || 0).toFixed(2)),
      UtilidadCalculada: Number((r.Utilidad || 0).toFixed(2)),
      PorcentajeUtilidad: Number((r.Porcentaje || 0).toFixed(2)),
    }));

    const option = {
      fileName: "ReporteVentasArticulosMP",
      datas: [
        {
          sheetData: resumenData,
          sheetName: "Resumen por Grupo",
          sheetFilter: ["Grupo", "CantidadDeArticulos", "Venta", "UtilidadCalculada", "PorcentajeUtilidad"],
          sheetHeader: ["Grupo", "Cantidad de Articulos", "Venta (dinero)", "Utilidad Calculada", "% Utilidad"],
        },
        {
          sheetData: dataExcel,
          sheetName: "ReporteVentasArticulosMP",
          sheetFilter,
          sheetHeader,
        },
      ],
    };

    const toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();
  }

  const headers = useMemo(() => {
    const base = [
      { name: "SKU", field: "SKU", sortable: true },
      { name: "Nombre", field: "Articulo", sortable: true },
    ];
    const porGrupo = [];
    gruposCols.forEach((g) => {
      porGrupo.push(
        { name: `Vendido ${g.name}`, field: kCant(g.id), sortable: true },
        { name: `Precio Prom Bruto ${g.name}`, field: kPPB(g.id), sortable: true },
        { name: `Costos ${g.name}`, field: kCost(g.id), sortable: true },
        { name: `Precio Prom Neto ${g.name}`, field: kPPN(g.id), sortable: true },
        { name: `Utilidad ${g.name}`, field: kUtil(g.id), sortable: true }
      );
    });
    const totales = [
      { name: "Total Vendido", field: "TotalCantidad", sortable: true },
      { name: "Total Precio Promedio Bruto", field: "TotalPrecioPromedioBruto", sortable: true },
      { name: "Total Precio Promedio Neto", field: "TotalPrecioPromedioNeto", sortable: true },
      { name: "Margen Bruto", field: "MargenBruto", sortable: true },
      { name: "Total Ventas Brutas", field: "TotalVentasBrutas", sortable: true },
      { name: "Total Ventas Netas", field: "TotalVentasNetas", sortable: true },
    ];
    return [...base, ...porGrupo, ...totales];
  }, [gruposCols]);

  const filteredComments = useMemo(() => {
    let computedComments = [...comments];

    if (search) {
      const searchLower = search.toLowerCase();
      computedComments = computedComments.filter((comment) => {
        const texto =
          `${comment.SKU || ""} ` +
          `${comment.Articulo || ""} ` +
          `${comment.Marca || ""} ` +
          `${comment.Linea || ""}`;
        const textoMatch = texto.toLowerCase().includes(searchLower);
        const numerosMatch = numericFields.some((field) =>
          String(comment[field] || "").includes(search)
        );
        return textoMatch || numerosMatch;
      });
    }

    if (selectedMarca && selectedMarca !== "0") {
      computedComments = computedComments.filter(
        (e) => String(e.idMarca || "") === String(selectedMarca)
      );
    }

    if (sorting.field) {
      const reversed = sorting.order === "asc" ? 1 : -1;
      computedComments.sort((a, b) => {
        const aValue = a[sorting.field];
        const bValue = b[sorting.field];
        if (numericFields.includes(sorting.field)) {
          return reversed * (Number(aValue || 0) - Number(bValue || 0));
        }
        return (
          reversed *
          String(aValue || "").localeCompare(String(bValue || ""), "es", {
            sensitivity: "base",
          })
        );
      });
    }

    setTotalItems(computedComments.length);

    return computedComments;
  }, [comments, search, sorting, selectedMarca, numericFields]);

  const commentsData = useMemo(() => {
    return filteredComments.slice(
      (currentPage - 1) * ITEMS_PER_PAGE,
      (currentPage - 1) * ITEMS_PER_PAGE + ITEMS_PER_PAGE
    );
  }, [filteredComments, currentPage]);

  // Resumen: Venta total por grupo
  const resumenGrupo = useMemo(() => {
    return gruposCols
      .map((g) => {
        let cantidad = 0;
        let venta = 0;
        let costo = 0;
        filteredComments.forEach((r) => {
          const c = Number(r[kCant(g.id)] || 0);
          const precio = Number(r[kPPN(g.id)] || 0);
          const costoU = Number(r[kCost(g.id)] || 0);
          cantidad += c;
          venta += precio * c;
          costo += costoU * c;
        });
        const utilidad = venta - costo;
        return {
          Grupo: g.name,
          Cantidad: cantidad,
          Venta: venta,
          Utilidad: utilidad,
          Porcentaje: venta > 0 ? (utilidad / venta) * 100 : 0,
        };
      })
      .filter((x) => x.Cantidad > 0 || x.Venta > 0);
  }, [filteredComments, gruposCols]);

  return (
    <>
      <Header />
      <SelectorGrupos
        isOpen={modalGrupos}
        onConfirm={confirmarGrupos}
        onClose={() => setModalGrupos(false)}
        allowClose={gruposSel.length > 0}
        initialSelected={gruposSel}
      />
      <br />
      <br />

      {user.menu_ventas ? (
        <div className="card col-12">
          <Row>
            <Col md={8}>
              <Button
                size="sm"
                href="/ReportesBI"
                className="btn btn-danger"
                id="botonListado"
              >
                Regresar
              </Button>
            </Col>

            <Col sm={4}>
              <ButtonGroup id="logoutBoton">
                <Button
                  size="sm"
                  className="btn"
                  color="primary"
                  onClick={excel}
                  disabled={!comments.length}
                >
                  Excel <i className="far fa-file-excel"></i>
                </Button>
              </ButtonGroup>
            </Col>
          </Row>

          <Modal size="sm" isOpen={modalMail} toggle={toggleMail}>
            <ModalHeader toggle={toggleMail}>
              <h4>Enviar Reporte Ventas Diario</h4>
            </ModalHeader>

            <ModalBody>
              <Label className="mr-sm-2">Email</Label>
              <Input
                className="col-sm-12"
                type="text"
                value={mailTo}
                required
                onChange={(e) => {
                  setMailTo(e.target.value);
                }}
              />
            </ModalBody>

            <ModalFooter>
              <Button size="sm" color="success">
                Enviar
              </Button>
            </ModalFooter>
          </Modal>

          <h3 align="center">Reporte Ventas por Grupo</h3>
          <div align="center" style={{ marginBottom: 8 }}>
            <small style={{ color: "#555" }}>
              Grupos: <b>{gruposInfo.map((g) => g.name).join(", ") || "—"}</b>{" "}
            </small>
            <Button size="sm" color="link" className="p-0" onClick={() => setModalGrupos(true)}>
              Cambiar grupos
            </Button>
          </div>

          <div className="row">
            <div className="col-md-8">
              <Pagination
                total={totalItems}
                itemsPerPage={ITEMS_PER_PAGE}
                currentPage={currentPage}
                onPageChange={(page) => setCurrentPage(page)}
              />
            </div>

            <div className="col-md-4 d-flex flex-row-reverse">
              <Search
                onSearch={(value) => {
                  setSearch(value);
                  setCurrentPage(1);
                }}
              />
            </div>
          </div>

          <Row>
            <Col md={2}>
              <Label className="mr-sm-2">Fecha Inicio</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaInicio}
                required
                onChange={(e) => {
                  setSelectedFechaInicio(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>

            <Col md={2}>
              <Label className="mr-sm-2">Fecha Fin</Label>
              <Input
                bsSize="sm"
                type="date"
                value={selectedFechaFin}
                required
                onChange={(e) => {
                  setSelectedFechaFin(e.target.value);
                  setFechaModificada(true);
                }}
              />
            </Col>

            <Col md={2}>
              <h4></h4>
              <Button
                size="sm"
                className="btn"
                id="botonListado"
                onClick={BuscaInfo}
                color={fechaModificada ? "danger" : "info"}
              >
                Actualizar
              </Button>
            </Col>

            <Col md={2}>
              <Label>Marcas</Label>
              <Input
                bsSize="sm"
                type="select"
                value={selectedMarca}
                onChange={(e) => {
                  setSelectedMarca(e.target.value);
                  setCurrentPage(1);
                }}
              >
                <option value="0">Selecciona</option>
                {marcas
                  .sort((a, b) => (a.name > b.name ? 1 : -1))
                  .map((a) => {
                    return (
                      <option key={a._id} value={a._id}>
                        {a.name}
                      </option>
                    );
                  })}
              </Input>
            </Col>
          </Row>

          <br />

          {!gruposSel.length ? (
            <h4 align="center" style={{ color: "#888", padding: "40px 0" }}>
              Selecciona uno o varios grupos para ver el reporte.
            </h4>
          ) : (
            <>
              {/* Resumen: Venta total por grupo */}
              <h4 align="center">Venta total por grupo</h4>
              <Table size="sm" striped borderless className="table-responsive-xl">
                <thead className="thead-light">
                  <tr>
                    <th>Grupo</th>
                    <th>Cantidad de Articulos</th>
                    <th>Venta (dinero)</th>
                    <th>Utilidad Calculada</th>
                    <th>% Utilidad</th>
                  </tr>
                </thead>
                <tbody>
                  {resumenGrupo.map((a, i) => (
                    <tr key={i}>
                      <td>{a.Grupo}</td>
                      <td>{number(a.Cantidad)}</td>
                      <td>{money(a.Venta)}</td>
                      <td style={{ color: a.Utilidad < 0 ? "#c62828" : "#2e7d32" }}>{money(a.Utilidad)}</td>
                      <td style={{ color: a.Porcentaje < 0 ? "#c62828" : "#2e7d32" }}>{percent(a.Porcentaje)}</td>
                    </tr>
                  ))}
                </tbody>
              </Table>
              <br />

              <h4 align="center">Detalle de venta por producto</h4>

              <div className="table-wrapper">
                <Table size="sm" striped borderless className="table-responsive-xl">
                  <TableHeader
                    headers={headers}
                    onSorting={(field, order) => setSorting({ field, order })}
                  />

                  <tbody>
                    {commentsData.map((a) => {
                      return (
                        <tr key={a.IdArticulo}>
                          <td>{a.SKU}</td>
                          <td>{a.Articulo}</td>

                          {gruposCols.map((g) => (
                            <React.Fragment key={g.id}>
                              <td>{number(a[kCant(g.id)])}</td>
                              <td>{money(a[kPPB(g.id)])}</td>
                              <td>{money(a[kCost(g.id)])}</td>
                              <td>{money(a[kPPN(g.id)])}</td>
                              <td style={utilidadStyle(a[kUtil(g.id)])}>
                                {money(a[kUtil(g.id)])}
                              </td>
                            </React.Fragment>
                          ))}

                          <td>{number(a.TotalCantidad)}</td>
                          <td>{money(a.TotalPrecioPromedioBruto)}</td>
                          <td>{money(a.TotalPrecioPromedioNeto)}</td>
                          <td style={marginStyle(a.MargenBruto)}>
                            {percent(a.MargenBruto)}
                          </td>
                          <td>{money(a.TotalVentasBrutas)}</td>
                          <td>{money(a.TotalVentasNetas)}</td>
                        </tr>
                      );
                    })}
                  </tbody>
                </Table>
              </div>

              <div className="col-md-6">
                <Pagination
                  total={totalItems}
                  itemsPerPage={ITEMS_PER_PAGE}
                  currentPage={currentPage}
                  onPageChange={(page) => setCurrentPage(page)}
                />
              </div>
            </>
          )}
        </div>
      ) : undefined}

      <br />
      {loader}
    </>
  );
}

export default ReporteVentasArticulosMP;
